/**
 * Created by jonas on 2021-02-02.
 */
import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {
    BrickSnake2000GameData,
    BrickSnake2000InitData,
    SymbolValues,
    WinData,
    WinLineData
} from "./BrickSnake2000Data";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {BrickSnake2000} from "../BrickSnake2000";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {CollectorSymbol} from "../reels/symbols/CollectorSymbol";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NineSlicePlane} from "pixi.js";

// first attempt at doing big symbols, probably not a very good one :joy:
export interface reelPosition {
    reelID:number,
    reelPosition:number
}
type reelPositionWithSymbol = reelPosition & {symbol:string};

export class BrickSnake2000Model extends GameModel<BrickSnake2000InitData, BrickSnake2000GameData> {

    public isRestore:boolean = false;
    //public visibleReelMatrix:StateMatrix<string>;
    //public evaluatedArea:StateMatrix<string>;
    //public winData:WinData;
    public wins:WinData[];
    public isRestoreFeatureBet:boolean;
    public buyFeatureName:string;
    public symbolValues?:SymbolValues;
    public totalWays:number;
    public xWaysSize:number;
    public totalWin:number;
    public winRatio:number;
    public fsWinRatio:number;
    public previousCollectorValue:number;
    public currentCollectorValue:number;
    public isGodModeDeluxe:boolean;
    public isGodMode:boolean;
    private parsedReels:reelPositionWithSymbol[];
    private parsedEvaluatedArea:reelPositionWithSymbol[];

    public hasWonFsClient:boolean = false;

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);

        this.currentCollectorValue = 0;
        this.previousCollectorValue = 0;

        api.events.once("featureBet", (data:boolean) => {
            this.isRestoreFeatureBet = data;
        });
        api.events.once("featureName", (data:string) => {
            this.buyFeatureName = data;
        });
        BrickSnake2000.apiPlugin.events.on(APIEvent.BET, (betData:APIFeatureBetEventData) => {
            for (let index = 0; index < BrickSnake2000.model.initData.featureBuyTimesBetValue.length; index++) {
                if (BrickSnake2000.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });

        BrickSnake2000.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData:APIFeatureBetEventData) => {
            for (let index = 0; index < BrickSnake2000.model.initData.featureBuyTimesBetValue.length; index++) {
                if (BrickSnake2000.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });

        BrickSnake2000.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, () => {
            const activeBetFeature = SlotKeypad.apiPlugIn.betFeatureController.getActiveBetFeature();
            if (activeBetFeature?.name == "BOOSTED_BET")
                BrickSnake2000.baseGameReelView.enableXBet()
            else
                BrickSnake2000.baseGameReelView.disableXBet()
        })

    }

    protected onInit(data:BrickSnake2000InitData):void {
        console.log("INIT DATA", data);
        super.onInit(data);
        this.symbolValues = data.symbolValues;
        this.isRestore = data.isRestoreState;
        this.updateCollectorValue(data.targetValue);
        this.isGodModeDeluxe = this.buyFeatureName == "GOD_MODE_DELUXE" && this.data.wasFeatureBuy;
        this.isGodMode = this.buyFeatureName == "GOD_MODE" && this.data.wasFeatureBuy;
        this.fsWinRatio = Math.round(this.data.freespinsWinnings / this.initData.bet);
    }

    public onGame(data:BrickSnake2000GameData):void {
        console.log("GAME DATA", data);
        super.onGame(data);
        this.isRestore = false;
        this.setupReels();
        this.setupEvaluatedArea();
        this.createWinData();
        this.totalWin = this.gameData.accumulatedRoundWin;
        this.winRatio = this.gameData.totalSpinWinnings / this.gameData.playedBetValue;
        this.fsWinRatio = Math.round(this.data.freespinsWinnings / this.gameData.playedBetValue);
        this.totalWays = this.gameData.betWayWins
            .map((win) => win.numberOfCombinations)
            .reduce((a,b) => a+b, 0);
        this.xWaysSize = this.gameData.symbolSizes
            .reduce((a,b) => a.concat(b), [])
            .reduce((a,b) => Math.max(a,b), 1);
        this.updateCollectorValue(data.targetValue);
        this.isGodModeDeluxe = this.buyFeatureName == "GOD_MODE_DELUXE" && this.data.wasFeatureBuy;
        this.isGodMode = this.buyFeatureName == "GOD_MODE" && this.data.wasFeatureBuy;
    }

    protected updateCollectorValue(newValue:number):void {
        this.previousCollectorValue = this.currentCollectorValue;
        this.currentCollectorValue = newValue;
    }

    public isBoostedBet():boolean {
        return this.data.boostedBet;
    }

    protected setupReels(): void {
        const overflowAdjustment = this.data.mode != GameMode.NORMAL ? 0 : 1;
        this.parsedReels =
            this.data.reels
                .map((reel, reelID) =>
                    reel.map((sym, reelPosition) => {
                        return {
                            symbol: sym,
                            reelID: reelID,
                            reelPosition: reelPosition - overflowAdjustment,
                        }
                    }))
                .reduce((a,b) => a.concat(b), []);
    }

    protected setupEvaluatedArea(): void {
        this.parsedEvaluatedArea =
            this.gameData.evaluatedArea
                .map((reel, reelID) =>
                    reel.map((sym, reelPosition) => {
                        return {
                            symbol: sym,
                            reelID: reelID,
                            reelPosition: reelPosition
                        }
                    }))
                .reduce((a,b) => a.concat(b), []);
    }


    private createWinData() {
        this.wins =  this.gameData.betWayWins.map((win) => {
            return {
                winLineData: win,
                winningPositions: this.parsedEvaluatedArea.filter((pos) => pos.reelID < win.length &&
                    (pos.symbol == win.symbol ||
                                   pos.symbol == "W"))
            }
        });
    }

    // win stuff
    public getWinningPositions(): reelPosition[] {
        const positions = this.wins.map((win) => win.winningPositions).reduce((a,b) => a.concat(b), []);
        return Array.from(new Set([...positions]));
    }

    public getNonWinningPositions(): reelPosition[] {
        return this.parsedEvaluatedArea.filter((pos) => this.getWinningPositions().indexOf(pos) == -1);
    }

    public getBaseGameSnakeData(): reelPosition[] {
        const isFSRestore =  this.isRestore && (this.data.mode == GameMode.FREESPIN ||
                                                this.data.mode == GameMode.FREESPIN_SUPER);
        const snakeData = isFSRestore ? this.initData.snakesEnteringFreespins : this.data.snakes;
        if (snakeData.length == 0)
            return [];
        return snakeData[0].pos.map((pos) => {
            return {reelID: pos[0], reelPosition:pos[1]}
        })
    }

    public getFreespinsSnakeData(): {totalLength:number, snakes:reelPosition[][], index:number[]} {
        const snakeData = this.data.snakes;
        const longestSnake = Math.max(...snakeData.map((snake) => snake.pos.length + snake.startTurn));
        const snakePaths = snakeData.map((snake) => {
            const movementArray:reelPosition[] = [];
            if (snake.dead) {
                snake.pos.forEach((pos, index) => {
                    movementArray[snake.startTurn + index] = {reelID: pos[0], reelPosition:pos[1]};
                });
            } else {
                snake.pos.slice(0, -1).forEach((pos, index) => {
                    movementArray[snake.startTurn + index] = {reelID: pos[0], reelPosition:pos[1]};
                });
            }
            return movementArray;
        })
        const snakeIDs = snakeData.map((snake) => snake.index);
        return {
            totalLength: longestSnake,
            snakes: snakePaths,
            index: snakeIDs
        };
        //return this.gameData.snakes.map((snakeData) => {
        //    return snakeData.pos.map((pos) => {
        //        return {reelID: pos[0], reelPosition:pos[1]}
        //    })
        //})
    }

    public stickyFreespinPosition(): reelPosition[] {
        return this.data.keptSymbols
                .map((reel, reelID) =>
                    reel.map((sym, reelPosition) => {
                        return {
                            symbol: sym,
                            reelID: reelID,
                            reelPosition: reelPosition
                        }
                    }))
                .reduce((a,b) => a.concat(b), [])
                .filter((pos) => pos.symbol != "X");
    }

    public numberOfKillers():number {
        return this.parsedReels.filter((sym) => sym.symbol == "K").length;
    }

    public getCollectorSymbolPosition():reelPosition {
        return this.parsedReels.find((sym) => sym.symbol == "TA")!;
    }

    public getFreespinsMaxWinPosition():reelPosition {
        return this.parsedReels.find((sym) => sym.symbol == "MA")!;
    }

    public isFreespins():boolean {
        return this.data.mode == GameMode.FREESPIN || this.data.mode == GameMode.FREESPIN_SUPER;
    }
}